import lang from '../../lib/language';

import InfoIcon from '../../assets/img/info-circle-red.svg';
import { useMaintenanceMode } from '../../hooks';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import MaintenanceNotice from '../MaintenanceNotice/MaintenanceNotice';

import styles from './TradingButtons.module.scss';

type Props = {
  isButtonsDisabled: boolean;
  onSellClicked: () => void;
  onBuyClicked: () => void;
  isSymbolHalted?: boolean;
};

const TradingButtons = (props: Props): JSX.Element => {
  const {
    isButtonsDisabled,
    onSellClicked,
    onBuyClicked,
    isSymbolHalted = false,
  } = props;
  const isMaintenance = useMaintenanceMode();

  // Checked first so the maintenance notice wins over every other status.
  if (isMaintenance) {
    return <MaintenanceNotice />;
  }

  if (isSymbolHalted) {
    return (
      <div className={styles.haltedSymbolInfo}>
        <div>
          <img src={InfoIcon} alt="" />
        </div>
        <div>
          {lang.commonHaltedSymbolPopupContent2()}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapperButtons}>
      <Button
        className={styles.btnSell}
        variant={ButtonTypesEnum.Secondary}
        disabled={isButtonsDisabled}
        fullWidth
        biggerFontSize
        onClick={onSellClicked}
      >
        {lang.commonOrderSideButtonSell()}
      </Button>
      <Button
        className={styles.btnBuy}
        disabled={isButtonsDisabled}
        fullWidth
        biggerFontSize
        onClick={onBuyClicked}
      >
        {lang.commonOrderSideButtonBuy()}
      </Button>
    </div>
  );
};

export default TradingButtons;
